function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.84862 38.913C6.97568 37.6403 3.94829 36.9329 0.852929 36.8093C0.846751 36.8093 0.840572 36.8093 0.834394 36.8093C0.587259 36.8093 0.380284 37.0039 0.371017 37.2541C0.361749 37.5105 0.559457 37.7268 0.815859 37.736C3.79692 37.8534 6.71001 38.5361 9.47483 39.7594C9.53661 39.7873 9.5984 39.7996 9.66327 39.7996C9.84244 39.7996 10.0093 39.6977 10.0865 39.5247C10.1915 39.2899 10.0865 39.018 9.85171 38.913H9.84862Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.84984 32.1879C5.51759 32.0056 10.1297 32.7408 14.5473 34.3719C14.5998 34.3905 14.6554 34.3997 14.7079 34.3997C14.8963 34.3997 15.0724 34.2823 15.1435 34.097C15.2331 33.856 15.1095 33.5904 14.8685 33.5008C10.3336 31.8295 5.60718 31.0758 0.81277 31.2611C0.556368 31.2704 0.35866 31.4866 0.367928 31.743C0.377195 31.9994 0.587259 32.2033 0.84984 32.1879Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.84675 26.0373C7.30931 25.8272 13.8398 27.1494 19.7463 29.8648C19.8081 29.8926 19.8761 29.9081 19.941 29.9081C20.1171 29.9081 20.2839 29.8092 20.3611 29.6393C20.4692 29.4076 20.3673 29.1327 20.1325 29.0245C14.0962 26.2474 7.41126 24.8943 0.815859 25.1136C0.559457 25.1229 0.35866 25.3361 0.367928 25.5925C0.377195 25.8489 0.58417 26.0528 0.84675 26.0404V26.0373Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8302 28.6137C24.0866 28.6137 24.2936 28.4067 24.2936 28.1503V10.8324C24.2936 10.8324 24.2936 10.8324 24.2967 10.8324H31.0991C31.3555 10.8324 31.5625 10.6254 31.5625 10.369C31.5625 10.1126 31.3555 9.90562 31.0991 9.90562H24.3338C24.618 7.66596 26.5333 5.92675 28.8502 5.92675C31.3617 5.92675 33.4067 7.97179 33.4067 10.4833V12.2287C33.4067 12.4851 33.6137 12.6921 33.8701 12.6921C34.1265 12.6921 34.3335 12.4851 34.3335 12.2287V10.4833C34.3304 7.46208 31.8714 5 28.8502 5C25.8289 5 23.3669 7.45899 23.3669 10.4833V28.1503C23.3669 28.4067 23.5738 28.6137 23.8302 28.6137Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.169 35.2647C41.142 35.2647 35.1984 37.7268 30.4318 42.1968C30.2928 42.3266 30.2496 42.5274 30.3206 42.7065C30.3917 42.8857 30.5647 43 30.7531 43C30.8921 43 31.0157 42.9382 31.0991 42.8425C35.6896 38.5547 41.3922 36.1914 47.169 36.1914C47.4254 36.1914 47.6324 35.9845 47.6324 35.7281C47.6324 35.4717 47.4254 35.2647 47.169 35.2647Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.169 30.3992C36.8357 30.3992 27.2685 34.5974 20.2314 42.2184C20.1078 42.3544 20.0769 42.549 20.151 42.7189C20.2252 42.8888 20.3951 42.9969 20.5773 42.9969C20.7318 42.9969 20.8677 42.9228 20.9511 42.8054C27.806 35.4006 37.1137 31.326 47.169 31.326C47.4254 31.326 47.6324 31.119 47.6324 30.8626C47.6324 30.6062 47.4254 30.3992 47.169 30.3992Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6324 24.7028C47.6324 24.4464 47.4254 24.2394 47.169 24.2394C33.3511 24.2579 20.3055 30.9954 12.2736 42.2648C12.1717 42.4069 12.1624 42.5922 12.2427 42.7467C12.3231 42.9011 12.4837 42.9969 12.6567 42.9969C12.8297 42.9969 12.981 42.9011 13.0614 42.756C20.9202 31.7585 33.6693 25.1816 47.169 25.1662C47.4254 25.1662 47.6324 24.9592 47.6324 24.7028Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5598 19.6674C28.6277 19.8466 28.8007 19.964 28.9923 19.964H30.4071V25.4102C30.4071 25.6666 30.6141 25.8736 30.8705 25.8736C31.1269 25.8736 31.3339 25.6666 31.3339 25.4102V19.5006C31.3339 19.2442 31.1269 19.0372 30.8705 19.0372H30.2032L36.9129 13.035L43.6226 19.0372H42.9554C42.699 19.0372 42.492 19.2442 42.492 19.5006V22.7751C42.492 23.0315 42.699 23.2385 42.9554 23.2385C43.2118 23.2385 43.4187 23.0315 43.4187 22.7751V19.964H44.8336C45.0251 19.964 45.1981 19.8466 45.2661 19.6674C45.334 19.4883 45.2846 19.2844 45.1425 19.1577L41.8463 16.2106V12.8342C41.8463 12.5778 41.6394 12.3708 41.383 12.3708C41.1266 12.3708 40.9196 12.5778 40.9196 12.8342V15.3827L37.2188 12.0711C37.0427 11.9136 36.777 11.9136 36.6009 12.0711L28.6772 19.1577C28.5351 19.2875 28.4856 19.4883 28.5536 19.6674H28.5598Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6552 22.9296C38.9116 22.9296 39.1186 22.7226 39.1186 22.4662V19.825C39.1186 19.5686 38.9116 19.3616 38.6552 19.3616H35.1768C34.9204 19.3616 34.7134 19.5686 34.7134 19.825V23.5629C34.7134 23.8193 34.9204 24.0263 35.1768 24.0263C35.4332 24.0263 35.6402 23.8193 35.6402 23.5629V20.2884H38.1918V22.4662C38.1918 22.7226 38.3988 22.9296 38.6552 22.9296Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04543 16.7821C11.2233 16.7821 12.9934 15.0089 12.9934 12.8311C12.9934 10.6532 11.2202 8.88001 9.04543 8.88001C6.87065 8.88001 5.09437 10.6532 5.09437 12.8311C5.09437 15.0089 6.86756 16.7821 9.04543 16.7821ZM9.04543 9.80985C10.7105 9.80985 12.0667 11.166 12.0667 12.8342C12.0667 14.5023 10.7105 15.8585 9.04543 15.8585C7.38037 15.8585 6.02113 14.5023 6.02113 12.8342C6.02113 11.166 7.37728 9.80985 9.04543 9.80985Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04543 6.84115C9.30184 6.84115 9.50881 6.63418 9.50881 6.37777V6.01634C9.50881 5.75994 9.30184 5.55296 9.04543 5.55296C8.78903 5.55296 8.58206 5.75994 8.58206 6.01634V6.37777C8.58206 6.63418 8.78903 6.84115 9.04543 6.84115Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58206 19.2751V19.6365C8.58206 19.8929 8.78903 20.0999 9.04543 20.0999C9.30184 20.0999 9.50881 19.8929 9.50881 19.6365V19.2751C9.50881 19.0187 9.30184 18.8117 9.04543 18.8117C8.78903 18.8117 8.58206 19.0187 8.58206 19.2751Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.15835 8.59581C4.24794 8.68539 4.36842 8.73173 4.4858 8.73173C4.60319 8.73173 4.72367 8.68539 4.81326 8.59581C4.99552 8.41354 4.99552 8.12007 4.81326 7.9409L4.55686 7.6845C4.37459 7.50224 4.08112 7.50224 3.90195 7.6845C3.71969 7.86676 3.71969 8.16023 3.90195 8.3394L4.15835 8.59581Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.534 17.9715C13.6236 18.0611 13.7441 18.1074 13.8615 18.1074C13.9789 18.1074 14.0993 18.0611 14.1889 17.9715C14.3681 17.7892 14.3681 17.4957 14.1889 17.3166L13.9325 17.0602C13.7533 16.881 13.4568 16.8779 13.2776 17.0602C13.0984 17.2424 13.0984 17.5359 13.2776 17.7151L13.534 17.9715Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.23379 13.2914H2.59523C2.85163 13.2914 3.0586 13.0844 3.0586 12.828C3.0586 12.5716 2.85163 12.3646 2.59523 12.3646H2.23379C1.97739 12.3646 1.77042 12.5716 1.77042 12.828C1.77042 13.0844 1.97739 13.2914 2.23379 13.2914Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4926 13.2914H15.854C16.1104 13.2914 16.3174 13.0844 16.3174 12.828C16.3174 12.5716 16.1104 12.3646 15.854 12.3646H15.4926C15.2361 12.3646 15.0292 12.5716 15.0292 12.828C15.0292 13.0844 15.2361 13.2914 15.4926 13.2914Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2294 18.1074C4.34679 18.1074 4.46727 18.0611 4.55686 17.9715L4.81326 17.7151C4.99552 17.5328 4.99552 17.2393 4.81326 17.0602C4.631 16.881 4.33752 16.8779 4.15835 17.0602L3.90195 17.3166C3.71969 17.4988 3.71969 17.7923 3.90195 17.9715C3.99154 18.0611 4.11201 18.1074 4.2294 18.1074Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6051 8.73173C13.7225 8.73173 13.8429 8.68539 13.9325 8.59581L14.1889 8.3394C14.3712 8.15714 14.3712 7.86367 14.1889 7.6845C14.0067 7.50532 13.7132 7.50224 13.534 7.6845L13.2776 7.9409C13.0953 8.12316 13.0953 8.41663 13.2776 8.59581C13.3672 8.68539 13.4877 8.73173 13.6051 8.73173Z",
    fill: "#1D1D1B",
    style: {
      fill: "#1D1D1B",
      fill: "color(display-p3 0.1137 0.1137 0.1059)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMw);
export default __webpack_public_path__ + "static/media/MW.ad7a3f77222cf844f591ce8a96239ca3.svg";
export { ForwardRef as ReactComponent };